
import React from "react";
import { useMedia } from "./context";
import MediaItem from "./MediaItem";
import { Loader2 } from "lucide-react";

const MediaGallery: React.FC = () => {
  const { filteredMedia, isEditMode, loading } = useMedia();
  
  console.log("MediaGallery rendering with", filteredMedia.length, "items");
  
  if (loading) {
    return (
      <div className="py-20 flex justify-center items-center">
        <Loader2 className="h-10 w-10 text-palsustain-green animate-spin" />
      </div>
    );
  }
  
  return (
    <section className={`py-8 ${isEditMode ? "pt-16" : ""}`}>
      <div className="container mx-auto px-4">
        {filteredMedia.length === 0 ? (
          <div className="text-center py-10">
            <p className="text-lg text-palsustain-charcoal/70">
              No media items found. {isEditMode && "Use the edit controls to add some!"}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filteredMedia.map((item) => (
              <div key={item.id} data-media-id={item.id} className="relative">
                <MediaItem item={item} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default MediaGallery;
